import { Texture } from "../../../texture";
import { Webgl2 } from "../../../webgl2";
import { Webgl2Component } from "../../webgl2-component";

export type TextureComponentProps = {
  texture: Texture;
};

export class TextureComponent extends Webgl2Component<TextureComponentProps> {
  public getRenderData(props: TextureComponentProps) {
    const material = Webgl2.materials.default;
    material.setTexture("u_texture0", props.texture);
    return { material };
  }
}

export default TextureComponent;
